import React, { useEffect, useState } from "react"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, formValueSelector, isDirty, reset } from "redux-form"
import { SwitchInputField } from "components/RenderInput"
import { FORM_NAMES, URL_PATHS } from "constants/index"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { SaveButton } from "components/Buttons"
import PhonePreview from "./phonePreview"
import { updateListScreenSetup } from "store/actions"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import BottomNavigation from "components/BottomNavigation"
import ColorPicker from "components/ColorPicker"

const CategoriesTab = ({
  formValues,
  history,
  isDirty,
  tabIsActive,
  resetForm,
  listScreenSetup,
  updateListScreenSetup,
  vendorConfig,
  layout,
  handleNext,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)
  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  const updateTemplate = () => {
    if (!formValues?.categoriesToggle && (layout === "2" || layout === "4")) {
      return true
    }
    return false
  }

  const onSave = () => {
    updateListScreenSetup({
      values: {
        ...listScreenSetup,
        categories_bg_color: formValues?.categoriesTabColor,
        categories_font_color: formValues?.categoriesTextColor,
        ...(updateTemplate() ? { template_id: "3" } : {}),
      },
      clientSetup: {
        ...vendorConfig,
        categorize_experiences: formValues?.categoriesToggle ? 1 : 0,
      },
    })
  }

  return (
    <React.Fragment>
      <Row className="mt-3">
        <Col xl={8}>
          <Card>
            <CardHeader>
              <h4>Categories</h4>
            </CardHeader>
            <CardBody>
              <Row>
                <Col xs="auto" className="mt-3">
                  <label>Categories:</label>
                </Col>
                <Col>
                  <Field
                    name="categoriesToggle"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              {formValues?.categoriesToggle && (
                <Row className="my-3">
                  <Col xs="auto" className="mt-2">
                    <label>Set up Categories:</label>
                  </Col>
                  <Col>
                    <SaveButton
                      type="button"
                      content="Categories"
                      onClick={() => {
                        history.push(URL_PATHS.MANAGE_CATEGORIES)
                      }}
                    />
                  </Col>
                </Row>
              )}
              <Row className="my-3">
                <Col xs="auto">
                  <label>Categories Tab Color:</label>
                </Col>
                <Col xs="auto">
                  <Field name="categoriesTabColor" component={ColorPicker} />
                </Col>
              </Row>
              <Row className="my-3">
                <Col xs="auto">
                  <label>Categories Text Color:</label>
                </Col>
                <Col xs="auto">
                  <Field name="categoriesTextColor" component={ColorPicker} />
                </Col>
              </Row>
            </CardBody>
          </Card>
          <BottomNavigation handleNext={handleNext} handleSave={onSave} />
        </Col>
        <Col xl={4} className="mt-4 d-none d-xl-block">
          <PhonePreview />
        </Col>
      </Row>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          onSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.LIST_SCREEN)

const mapStateToProps = state => ({
  formValues: selector(state, "categories"),
  isDirty: isDirty(FORM_NAMES.LIST_SCREEN)(state, ...["categories"]),
  listScreenSetup: state.ListScreen.listScreenSetup,
  vendorConfig: state.clients.vendorConfig,
  layout: selector(state, "layout.layout"),
})

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset(FORM_NAMES.LIST_SCREEN)),
  updateListScreenSetup: values => dispatch(updateListScreenSetup(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CategoriesTab))
